module.exports = __webpack_public_path__ + "img/icon-xuexili-logo.b364a9d7.png";